// Base URL for Forkify API (v2)
export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';

// API key used for authentication with the Forkify API
export const KEY = 'c3e5580d-7f26-4b2e-ba43-a3d151d20aa5';

// Maximum time (in seconds) allowed for a fetch request before timeout error
export const TIMEOUT_SEC = 10;

// Number of recipes shown per page in pagination
export const RESULTS_PER_PAGE = 10;

// Time (in seconds) before closing success/error model automatically
export const MODEL_CLOSE_SEC = 2.5;